import {EnvironmentProviders, inject, InjectionToken, makeEnvironmentProviders} from '@angular/core';

//Mode routeur : chaque page de l’application a sa propre URL, affichée dans la barre d’adresse
//(lien direct, rechargement, précédent / suivant). L’accueil est à la racine et la saisie du code
//client sous /login.
//Sans lui (mode par défaut), l’URL affichée reste /main et la saisie du code client est à la racine.
export const VAL_MODE_ROUTEUR = new InjectionToken<boolean> ("VAL_MODE_ROUTEUR", {providedIn: 'root', factory: () => false});

//Chemin de la page de saisie du code client en mode routeur, à déclarer dans les routes de l’application
export const CheminConnexionModeRouteur = "login";

//Représente les chemins communs à toutes les applications
export interface CheminsApplication
{
  //Page d’accueil, une fois connecté
  accueil: string;

  //Page de saisie du code client
  connexion: string;
}

//Retourne les chemins communs de l’application, selon son mode
//  Retourne
//    Les chemins. À appeler dans un contexte d’injection
export function RetournerCheminsApplication () : CheminsApplication
{
  if (inject (VAL_MODE_ROUTEUR))
    return {accueil: "/", connexion: "/" + CheminConnexionModeRouteur};

  return {accueil: "/main", connexion: "/"};
}

//Passe l’application en mode routeur. À poser dans la configuration de l’application
export function provideModeRouteur () : EnvironmentProviders
{
  return makeEnvironmentProviders ([{provide: VAL_MODE_ROUTEUR, useValue: true}]);
}
